/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Studio_ReplaceInputs */

const en_landing_studio_replace = /** @type {(inputs: Landing_Studio_ReplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Replace`)
};

const zh_landing_studio_replace = /** @type {(inputs: Landing_Studio_ReplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更换`)
};

/**
* | output |
* | --- |
* | "Replace" |
*
* @param {Landing_Studio_ReplaceInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_studio_replace = /** @type {((inputs?: Landing_Studio_ReplaceInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Studio_ReplaceInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_studio_replace(inputs)
	return zh_landing_studio_replace(inputs)
});
export { landing_studio_replace as "landing.studio.replace" }